<div class="module3">
    <div class="text">
        <p class="t1">КАКИМ БУДЕТ ТВОЕ ПУТЕШЕСТВИЕ?</p>
        <p class="t2">Выбери подходящий формат</p>
    </div>
    <div class="navigation">
        <div class="navigationUp">
            <a href="/workingOut">
                <div class="imgBox">
                    <img src="photo/IMG_8.jpg" class="photo" alt="фото_3" />
                    <p class="textNav">ГАЙДЫ ПО МОСКВЕ</p>
                </div>
            </a>
            <a href="/workingOut">
                <div class="imgBox">
                    <img src="photo/IMG_1.jpg" class="photo" alt="фото_4" />
                    <p class="textNav">ГАЙДЫ ПО РОССИИ</p>
                </div>
            </a>
        </div>
        <div class="navigationLow">
            <a href="/workingOut">
                <div class="imgBox">
                    <img src="photo/IMG_4.jpg" class="photo" alt="фото_5" />
                    <p class="textNav">ЭКСКУРСИИ</p>
                </div>
            </a>
            <a href="/sanatoriums">
                <div class="imgBox">
                    <img src="photo/IMG_3.jpg" class="photo" alt="фото_6" />
                    <p class="textNav">САНАТОРИИ ДЛЯ ДЕТЕЙ</p>
                </div>
            </a>
        </div>
    </div>
</div>

<style>
    .module3 {
        /* width: fit-content; */
        margin: 0 auto;
        position: relative;
        /* height: 1200px; */
        margin-top: 20px;
    }
    /*ТЕКСТ*/
    .text {
        /* position: center; */
        left: 0;
        right: 0;
        /* top: 70px; */
        width: 100%;
        margin: 0 auto;
        text-align: center;
        /* margin: 20px; */
    }

    .t1,
    .t2 {
        color: #4f7942;
    }

    .t1 {
        margin-bottom: -10px;
    }

    .t2 {
        margin-bottom: 20px;
    }
    /*КАРТИНКИ*/
    .navigationUp,
    .navigationLow {
        left: 0;
        right: 0;
        margin: 0 auto;

        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px; /*Отступ между элементами*/
    }

    .photo {
        border-radius: 10px;
        width: 100%;
        display: block;
        margin: 0 auto;
        position: relative;
        filter: brightness(80%);
        box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
        transition: all 0.3s ease-in-out; /*Скорость изменения*/
    }

    .imgBox:hover .photo {
        filter: brightness(90%);
        box-shadow: rgb(38, 57, 77) 0px 30px 40px -10px;
    }

    .imgBox {
        cursor: pointer; /*Курсор при наведении*/
        position: relative;
        display: flex; /* Добавляем flexbox */
        flex-direction: column; /* Выравниваем по вертикали */
        justify-content: center; /* Центрируем по вертикали */
        align-items: center; /* Центрируем по горизонтали (если нужно) */
    }

    .textNav {
        position: absolute;
        text-align: center;
        color: #eaf4e5;
        padding: 40px;
    }

    @media (min-width: 1280px) {
        .module3 {
            width: 50%;
            margin-bottom: 50px;
        }

        .t1 {
            font-size: 30px;
        }
        .t2 {
            font-size: 20px;
            font-weight: 100;
        }
        .navigationLow {
            margin-top: 30px;
        }
        .textNav {
            font-size: 36px;
            font-weight: 600;
        }
    }
    @media (max-width: 480px) {
        .module3 {
            width: 90%;
            margin-bottom: 25px;
        }
        .t1 {
            font-size: 30px;
            font-weight: 700;
        }
        .t2 {
            font-size: 15px;
            font-weight: 100;
        }
        .navigationLow {
            margin-top: 25px;
        }
        .textNav {
            font-size: 15px;
            font-weight: 700;
        }
    }
    @media (min-width: 481px) and (max-width: 833px) { /*Телефон горизонталь*/
        .module3 {
            width: 90%;
            margin-bottom: 25px;
        }
        .t1 {
            font-size: 30px;
            font-weight: 700;
        }
        .t2 {
            font-size: 15px;
            font-weight: 100;
        }
        .navigationLow {
            margin-top: 25px;
        }
        .textNav {
            font-size: 20px;
            font-weight: 700;
        }
    }
    @media (min-width: 834px) and (max-width: 1023px) { /*Планшет*/
        .module3 {
            width: 90%;
            margin-bottom: 25px;
        }
        .t1 {
            font-size: 30px;
            font-weight: 700;
        }
        .t2 {
            font-size: 15px;
            font-weight: 100;
        }
        .navigationLow {
            margin-top: 25px;
        }
        .textNav {
            font-size: 20px;
            font-weight: 700;
        }
    }
    @media (min-width: 1024px) and (max-width: 1279px){ /*Планшет2*/
        .module3 {
            width: 90%;
            margin-bottom: 30px;
        }
        .t1 {
            font-size: 40px;
            font-weight: 700;
        }
        .t2 {
            font-size: 25px;
            font-weight: 100;
        }
        .navigationLow {
            margin-top: 30px;
        }
        .textNav {
            font-size: 30px;
            font-weight: 700;
        }
    }
</style>
